import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, getToken, ServerErrorResponse } from './constants';
import { ProfileResponse } from 'types/profile_response';
import AuthUtil from 'utils/AuthUtil';
const url = `${baseApiUrl()}/lexid/admin-user-auth/v1/profile`;

export const getProfile = async (onError?: (errors: ServerErrorResponse) => void) => {
  const idToken = getToken();
  if (!idToken || AuthUtil.isTokenExpired()) return null;

  try {
    const data = await fetcher({
      method: 'get',
      url: `${url}`,
    });
    return data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      const errorObj = JSON.parse(error.message);
      if (errorObj.message?.includes('not authorized') || errorObj.message?.includes('explicit deny')) {
        // Clear storage and trigger redirect
        AuthUtil.clearStorage();
        window.location.href = '/admin/dashboard';
        return null;
      }
    }
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useProfile(options = {}, onError?: (errors: ServerErrorResponse) => void) {
  const idToken = getToken();
  return useQuery<ProfileResponse, ServerErrorResponse>(['profile', idToken], async () => getProfile(onError), {
    ...options,
    keepPreviousData: false,
    enabled: !!(idToken && idToken.length > 0),
  });
}
